import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { of, switchMap } from 'rxjs';
import { OAuthService } from '../services/oauth.service';

export const AuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(OAuthService);
  const router = inject(Router);

  return authService.isLoggedIn().pipe(
    switchMap((isLogged) => {
      if (isLogged) {
        return of(true);
      }
      // Redirect to login page keeping the requested URL as query param
      return of(router.parseUrl(`/login?redirectTo=${encodeURIComponent(state.url)}`));
    }),
  );
};
